import React from "react";
import { NavItem, NavLink } from "react-bootstrap";

const FaqsTabItem = ({ title, eventKey, index,icon}) => {
  return (
    <>
      <NavItem key={index}>
        <NavLink eventKey={eventKey} >
          <li className="faqs__single_box_icon">
            <span>
              {" "}
              {icon}
            </span>
            
          </li>
          {title}
        </NavLink>
      </NavItem>
    </>
  );
};

export default FaqsTabItem;
